import { request } from './_request.js';
import type {
  ProjectIntakeOptions,
  CreateProjectInput,
  CreateProjectResponse,
} from '../../types/project-intake.js';

/**
 * 案件起票 API クライアント。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件起票フォームの選択肢取得と起票実行を行う API クライアント
 * @graph-connects /project-intake/options [calls, via:GET] 起票フォームの選択肢を取得
 * @graph-connects /project-intake/projects [calls, via:POST] 案件を起票する
 */
export const projectIntakeApi = {
  /** 起票フォームのプルダウン選択肢（事業・チーム・メンバー）を取得する。 */
  getOptions: async (): Promise<ProjectIntakeOptions> =>
    request<ProjectIntakeOptions>('/project-intake/options'),

  /** 案件を起票する（Backlog チケット + Slack チャンネル + 案件仕様書コピー）。 */
  createProject: async (payload: CreateProjectInput): Promise<CreateProjectResponse> =>
    request<CreateProjectResponse>('/project-intake/projects', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
